import React, { Suspense } from 'react';
import LoadingScreen from '../components/LoadingScreen';
// import { useLocation } from 'react-router-dom';

const Loadable = (Component) => (props) =>
  (
    // const { pathname } = useLocation();
    // const isDashboard = pathname.includes('/dashboard');

    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
export default Loadable;
